<template>
  <div>
    <template v-if="aboutLocation">
      <v-row>
        <v-col class="tcdc-map-height d-relative">
          <div id="location-map" style="width: 100%; height: 100%; position: relative"></div>
<!--          <GmapMap-->
<!--                  :center="{ lat: aboutLocation.lat, lng: aboutLocation.lon }"-->
<!--                  :options="mapOptions"-->
<!--                  :zoom="7"-->
<!--                  style="width: 100%; height: 100%;"-->
<!--          >-->
<!--            <GmapMarker-->
<!--                    :position="{ lat: aboutLocation.lat, lng: aboutLocation.lon }"-->
<!--                    :clickable="false"-->
<!--                    :draggable="false"-->
<!--            />-->
<!--          </GmapMap>-->
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div class="vhtml" v-html="aboutLocation[`description_${lang}`]"></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <p class="text-tcdc-green bold sub-header2">Address</p>
          <div class="vhtml" v-html="aboutLocation[`address_${lang}`]"></div>
        </v-col>
        <v-col>
          <p class="text-tcdc-green bold sub-header2">Postal Address</p>
          <div class="vhtml" v-html="aboutLocation[`postal_address_${lang}`]"></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <p class="text-tcdc-green bold sub-header2">Opening Hours</p>
          <div class="vhtml mb-3" v-html="aboutLocation[`opening_hours_detail_${lang}`]"></div>
          <v-layout justify-space-between class="vhtml" v-for="(item,i) in aboutLocation.opening_hours" :key="i">
              <v-flex shrink v-if="item.show_date">
                {{item[`day_${lang}`]}}
              </v-flex>
              <v-flex shrink v-if="item.show_date">
                {{item.is_open === 0 ? $t('service.locationClose'):item.time}}
              </v-flex>
          </v-layout>
        </v-col>
      </v-row>
      <v-row v-if="aboutLocation.attached_website">
        <v-col>
          <GreenButton @onPress="openLink(aboutLocation.attached_website)" :label="`visit ${aboutLocation.branch.branch_name_en}`" />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import GreenButton from "../../components/buttons/GreenButton";
import { mapState } from 'vuex';
import { mapStyles } from "../../config"

export default {
  data: () => ({
    mapOptions: {
      ...mapStyles,
      clickableIcons: true,
    },
    locationMap: undefined
  }),
  components: {
    GreenButton
  },
  computed: {
    ...mapState({
      branchName: state => state.Branch.branch_name,
      lang: state => state.Branch.lang,
      aboutLocation: state => state.About.location,
      googlePlace: state => state.About.location?.google_place_id
    })
  },
  mounted() {
    this.$nextTick(async () => {
      await new Promise((res, rej) => setTimeout(res, 200))
      window.addEventListener('load', this.initMap());
    })
  },
  watch: {
    googlePlace: function () {
      this.initMap()
    }
  },
  methods: {
    async openLink(website) {
      if (website) {
        await this.$store.dispatch('Branch/getBranchById', this.aboutLocation.branch.branch_id);
        await this.$store.dispatch("ServiceMenu/getServiceMenuByBranch", {
          branch_id: this.aboutLocation.branch.branch_id,
          lang: this.lang
        });
        let newname = this.$router.currentRoute.fullPath;
        newname = newname.split('/')[2];
        // console.log(`/${this.lang}`+'/'+newname+website);
        if (website[0] === '/') {
          this.$router.push(`/${this.lang}`+'/'+newname+website);
        } else {
          this.$router.push(`/${this.lang}`+'/'+newname+ '/' + website);
        }
      }
    },
    async initMap () {

      if (this.googlePlace) {
        this.$nextTick(() => {
          document.getElementById('location-map').innerHTML = this.googlePlace
        })
      }

      // The location
      // const position = { lat: this.aboutLocation.lat, lng: this.aboutLocation.lon };
      // // Request needed libraries.
      // const { Map } = await google.maps.importLibrary("maps");
      // const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");
      //
      // this.locationMap = new Map(document.getElementById("location-map"), {
      //   zoom: 17,
      //   center: position,
      //   disableDefaultUI: false,
      //   mapId: "location_map"
      // });
      //
      //
      // // The marker, positioned at Uluru
      // const marker = new AdvancedMarkerElement({
      //   map: this.locationMap,
      //   position,
      //   title: "Location"
      // });
      //
      // if (this.aboutLocation.google_place_id) {
      //   const service = new google.maps.places.PlacesService(this.locationMap);
      //   service.getDetails({
      //     placeId: this.aboutLocation.google_place_id // Replace with the actual place ID of the location
      //   }, (place, status) => {
      //     if (status === google.maps.places.PlacesServiceStatus.OK) {
      //       // Create a custom place card
      //       let div = document.createElement('div')
      //       div.setAttribute('id', 'location-place-card')
      //       document.getElementById("location-map").appendChild(div)
      //
      //       let placeCard = document.getElementById('location-place-card');
      //       placeCard.innerHTML =
      //           '<div class="map-container">' +
      //           '    <div class="placeDiv">' +
      //           '        <div class="placecard__container">' +
      //           '          <div class="placecard__left">' +
      //           '            <p class="placecard__business-name">' + place.name + '</p>' +
      //           '            <p class="placecard__info">' + place.formatted_address + '</p>' +
      //           '          </div>' +
      //           '          <div class="placecard__right">' +
      //           '              <a class="placecard__direction-link" target="_blank" href="' + place.url + '">' +
      //           '                  <div class="placecard__direction-icon"></div>' +
      //           '                  ' + this.$t('about.directions') +
      //           '              </a>' +
      //           '          </div>' +
      //           '        </div>' +
      //           '    </div>' +
      //           '</div>'
      //     }
      //   })
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.tcdc-map-height {
  height: 600px;
}

</style>
